module.exports = __webpack_public_path__ + "img/diagnostic.52cdf753.png";